<template>
    <edit-view-base :filter="filter" :has-card-view="true" :cards="cards" :tabs="tabs" :main-form="mainForm" :claim-name="claimName" :api-method="apiMethod" :item-id="itemId" :refresh-key="refreshKey" :has-import="true" />
</template>

<script>
    export default {
        props: [
            'filter',
            'itemId',
            'refreshKey'
        ],

        components: {
            editViewBase: () => import('../components/EditViewBase')
        },

        data() {
            return {
                cards: [
                    { title: 'Feed Purchase', apiMethod: 'FeedPurchases', form: () => import('../forms/FeedPurchaseForm'), items: [], filter: {}, dialog: false, isVisible: true, isMainCard: true },
                    { title: 'Feeding', apiMethod: 'Feedings', parentForeignKey: 'feedPurchaseId', form: () => import('../forms/FeedingForm'), items: [], filter: {}, dialog: false, isVisible: true },
                ],
                tabs: [
                    { text: 'Feedings', value: 'feedPurchaseId', isCard: true, table: () => import('../tables/FeedingsTable') },
                ],
                mainForm: () => import('../forms/FeedPurchaseForm'),
                claimName: 'FeedPurchases',
                apiMethod: 'FeedPurchases',
            }
        }
    };
</script>
